import { createApp } from 'vue';
import VTooltip from '../components/tooltip.vue';

const my_components = document.getElementsByClassName('v-tooltip');

for (let i = 0; i < my_components.length; i++) {
  createApp({
    components: {
      VTooltip,
    },
  }).mount(`#${my_components[i].id}`);
}
